module.exports = __webpack_public_path__ + "img/zamena.02208ffa.gif";